
import DealList from '@/components/DealList.vue'
import Loading from '@/components/Loading.vue'
import CollectionPageStructuredData from '@/components/CollectionPageStructuredData.vue'
import { buildOgLocaleMeta, buildOgImageMeta } from '@/utils/seo'

export default {
  name: 'Deals',
  components: { DealList, Loading, CollectionPageStructuredData },
  data() {
    return {
      deals: null,
      breadcrumb_list: [
        {
          text: this.$t('pages.bonnesAffaires.index.home'),
          to: { name: 'index' },
        },
        {
          text: this.$t('pages.bonnesAffaires.index.dealsLabel'),
          to: {
            name: 'bonnes-affaires',
          },
        },
      ],
    }
  },
  async fetch() {
    await this.$goodDealService
      .fetchDealsIndex()
      .then(({ data }) => {
        this.deals = data
      })
  },
  computed: {
    dealItems() {
      return (this.deals || []).map(deal => ({
        name: deal.title,
        url:
          this.$config.url +
          this.localePath({
            name: 'bonnes-affaires-slug',
            params: { slug: deal.slug },
          }),
      }))
    },
  },
  head() {
    return {
      title: this.$t('pages.bonnesAffaires.index.metaTitle'),
      link: [
        {
          rel: 'canonical',
          hid: 'canonical',
          href:
            this.$config.url +
            this.localePath({
              name: 'bonnes-affaires',
            }),
        },
      ],
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('pages.bonnesAffaires.index.metaDescription'),
        },
        { hid: 'og:type', name: 'og:type', content: 'website' },
        {
          hid: 'og:url',
          name: 'og:url',
          content: this.$config.url + this.$route.path,
        },
        {
          hid: 'og:title',
          name: 'og:title',
          content: this.$t('pages.bonnesAffaires.index.metaTitle'),
        },
        {
          hid: 'og:description',
          name: 'og:description',
          content: this.$t('pages.bonnesAffaires.index.metaDescription'),
        },
        {
          hid: 'og:site_name',
          name: 'og:site_name',
          content: 'AGM Vision',
        },
        ...buildOgLocaleMeta(this.$i18n.locale),
        ...buildOgImageMeta({
          url: `${this.$config.url}/logo_og.png`,
          width: 512,
          height: 512,
          alt: this.$t('pages.bonnesAffaires.index.metaTitle'),
        }),
        {
          hid: 'twitter:title',
          name: 'twitter:title',
          content: this.$t('pages.bonnesAffaires.index.metaTitle'),
        },
        {
          hid: 'twitter:description',
          name: 'twitter:description',
          content: this.$t('pages.bonnesAffaires.index.metaDescription'),
        },
      ],
    }
  },
}
